export const LoteExamNames = [
  'ARABIC',
  'HAITIAN',
  'CHINESE-SIMPLE',
  'HINDI',
  'GREEK',
  'FRENCH',
  'GERMAN',
  'HEBREW',
  'BENGALI',
  'JAPANESE',
  'KOREAN',
  'LATIN',
  'CHINESE-TRAD',
  'ALBANIAN',
  'RUSSIAN',
  'SPANISH',
  'ITALIAN',
  'URDU',
  'VIETNAMESE',
  'PUNJABI',
  'POLISH',
] as string[];
